import React from 'react'


const WorkTitle = () => {
  return (
    <div className='relative font-["Open_sans"] font-black text-white text-center md:text-end  '>
      <div className='opacity-80 animate__animated animate__slideInDown md:max-w-[1060px] mx-auto'>


          <div className='md:hidden text-[105px] tracking-[10px] leading-[80%]'>
            <p> 
                WORK
            </p>
          </div>
          <div className='hidden md:inline tracking-[30px] lg:hidden text-center text-[200px] leading-[80%]'>
            <p> 
                WORK
            </p>
   
          </div>
          <div className='hidden lg:flex flex-col  text-center text-[194px] leading-[90%]'>
            <p className=''> 
                MY WORK
            </p>

            </div>
          </div>



    </div>
  )
}

export default WorkTitle
